import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "./../../../../server";
import { AUTH_PRIVILEGES, AUTHENTICATE_USER, AUTHORIZE_USER, LOGOUT } from "../api";
import apiService from "./../../../../server";

export function authenticateUser(mobileNumber:any) {
    const postData = {
        "mobileNumber": mobileNumber,
    };
    return apiService.post(AUTHENTICATE_USER,
        postData,
    );
}

export function authorizeUser(mobileNumber:any, otp:any) {
    const postData = {
        "mobileNumber": mobileNumber,
        "onetimepassword": otp
    };
    return apiService.post(AUTHORIZE_USER,
        postData,
    );
}
export function fetchPrivileges() {
    return apiService.get(AUTH_PRIVILEGES);
}

/** Bypass apiService interceptor — logout must always succeed client-side */
export function logout() {
    return axios.post(`${API_URL}${LOGOUT}`, {}, {
        withCredentials: true,
        headers: { 'X-Client-Type': 'WEB', 'Content-Type': 'application/json' },
    });
}

export function resolveErrorMessage(errorResponse: any): string {
    if (errorResponse == null) {
        return 'Something went wrong.';
    }
    if (typeof errorResponse === 'string') {
        return errorResponse.trim() || 'Something went wrong.';
    }

    const payload = errorResponse?.response?.data ?? errorResponse;
    if (typeof payload === 'string') {
        return payload.trim() || 'Something went wrong.';
    }
    if (payload && typeof payload === 'object') {
        const msg = payload.message || payload.error || payload.title;
        if (typeof msg === 'string' && msg.trim()) {
            return msg.trim();
        }
    }

    if (typeof errorResponse?.message === 'string'
        && errorResponse.message.trim()
        && !errorResponse.message.startsWith('Request failed with status code')) {
        return errorResponse.message.trim();
    }

    const status = errorResponse?.response?.status ?? payload?.status;
    if (status === 401) return 'Your session has expired. Please log in again.';
    if (status === 403) return 'You do not have permission to perform this action.';
    if (status === 404) return 'The requested resource was not found.';
    if (status >= 500) return 'A server error occurred. Please try again later.';

    return 'Something went wrong.';
}

function resolveErrorTitle(errorResponse: any): string {
    const status = errorResponse?.response?.status
        ?? errorResponse?.response?.data?.status
        ?? errorResponse?.status;
    if (status === 401) return 'Session expired';
    if (status === 403) return 'Access denied';
    if (status === 404) return 'Not found';
    if (status >= 500) return 'Server error';
    return 'Oops';
}

export function formatError(errorResponse: any) {
    const text = resolveErrorMessage(errorResponse);
    return Swal.fire({
        icon: 'error',
        title: resolveErrorTitle(errorResponse),
        text,
        confirmButtonText: 'OK',
        confirmButtonColor: '#dc3545',
        allowOutsideClick: false,
        allowEscapeKey: true,
    });
}

export function formatSuccess(successMessage: any) {
    const text = typeof successMessage === 'string'
        ? successMessage
        : successMessage?.message || 'Done';
    return Swal.fire({
        icon: 'success',
        title: 'Success!',
        text,
        confirmButtonText: 'OK',
        confirmButtonColor: '#198754',
        allowOutsideClick: false,
        allowEscapeKey: true,
    });
}
